import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import { Icon } from '../Icon';
import { NFTItem } from '../NFTItem';
import styles from './index.module.less';
export const NFTList = ({ onPick, tokens, className, pickable, ...rest }) => {
    return (_jsx("div", { className: classnames(className, styles.selectList), ...rest, children: _jsxs("ul", { className: styles.list, children: [tokens.map((token) => (_jsx("li", { className: styles.item, children: _jsx(NFTItem, { token: token, className: styles.nft }) }, token.tokenId))), pickable && (_jsx("li", { className: styles.item, children: _jsx("div", { className: styles.addItem, onClick: onPick, role: "button", children: _jsx(Icon, { type: "add", size: 24 }) }) }))] }) }));
};
